export const VIMEO_REGEX = /(http|https)?:\/\/(www\.|player\.)?vimeo.com\/(?:|\/\?)/; // eslint-disable-line
export const URL_REGEX = /^(?:http(s)?:\/\/)+[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/; // eslint-disable-line
